import { i18n } from '@zet/localization'
import { create } from 'zustand'

type LanguageStore = {
  locale: string
  setLocale: (payload: string) => void
}

const useLanguageStore = create<LanguageStore>((set) => ({
  locale: i18n.locale,
  setLocale: (payload) => set((state) => ({ ...state, locale: payload })),
}))

export default useLanguageStore
